import { Component, input } from '@angular/core';

@Component({
  selector: 'crm-tgbot-avatar',
  imports: [],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
})
export class AvatarComponent {
  avatarUrl = input<string>();
  name = input<string>();
}
